var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 161.176 99.6153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M109.663 82.6694V16.5934C109.663 7.4343 102.233 0 93.0798 0C83.9264 0 76.4966 7.4343 76.4966 16.5934V82.9866C76.4966 85.7026 77.1504 88.4583 78.5571 91.0157C82.9952 99.0447 93.0798 101.959 101.084 97.5182C106.651 94.4454 109.762 88.6367 109.643 82.6694",
    fill: "var(--fill-0, #839BCF)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M161.176 16.5934C161.176 25.7524 153.746 33.1867 144.593 33.1867C135.439 33.1867 128.01 25.7524 128.01 16.5934C128.01 7.4343 135.439 0 144.593 0C153.746 0 161.176 7.4343 161.176 16.5934Z",
    fill: "var(--fill-0, #434DA1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M161.176 82.9866C161.176 92.1457 153.746 99.58 144.593 99.58C135.439 99.58 128.01 92.1457 128.01 82.9866C128.01 73.8276 135.439 66.3933 144.593 66.3933C153.746 66.3933 161.176 73.8276 161.176 82.9866Z",
    fill: "var(--fill-0, #839BCF)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M33.1664 82.7686V16.5934C33.1664 7.4343 25.7366 0 16.5832 0C7.42974 0 0 7.4343 0 16.5934V82.947C0 85.663 0.653817 88.4385 2.06052 90.9959C6.47874 99.0249 16.5832 101.939 24.5875 97.4984C30.1152 94.4454 33.2258 88.6764 33.1466 82.7487",
    fill: "var(--fill-0, #434DA1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M107.325 25.0784C108.791 22.6003 109.643 19.7059 109.643 16.6132C109.643 7.45413 102.213 0.0198248 93.06 0.0198248C86.9973 0.0198248 81.6875 3.27109 78.7949 8.148L40.4772 74.6602C37.644 79.5371 37.3667 85.7423 40.2791 91.0355C44.7171 99.0646 54.8018 101.979 62.8061 97.5381C65.5997 95.9917 67.7592 93.7713 69.2254 91.1941L107.325 25.0784Z",
    fill: "var(--fill-0, #434DA1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M69.0867 25.0784C70.5528 22.6003 71.4048 19.7059 71.4048 16.6132C71.4048 7.45413 63.975 0.0198248 54.8216 0.0198248C48.7589 0.0198248 43.4491 3.27109 40.5565 8.148L2.25864 74.6206C-0.574567 79.4975 -0.851944 85.7026 2.06051 90.9959C6.49855 99.0249 16.5832 101.939 24.5875 97.4984C27.3811 95.9521 29.5407 93.7317 31.0068 91.1545L69.0867 25.0784Z",
    fill: "var(--fill-0, #839BCF)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDots);
export default __webpack_public_path__ + "static/media/logo-dots.651ba4550868f1defa13dc25f1311731.svg";
export { ForwardRef as ReactComponent };